import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import PlaceComponent from "./components/place.component";
import Locations from "./Locations";
import { Provider, ErrorBoundary, LEVEL_WARN } from '@rollbar/react'; // Provider imports 'rollbar'

// move to hosted version on s3 or npoint? https://www.npoint.io/
// import deliveryStores from './data/delivery_stores.json';
// import deliveryStates from './data/delivery_states.json';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

const rollbarConfig = {
  accessToken: '085577f54cac4a318dbe1695519dcde3',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  server: {
    code_version: "0.1.1"
  },
  enabled: ('production' === process.env.NODE_ENV)
};

const ErrorDisplay = ({ error, resetError }) => ( // <-- props passed to fallbackUI component
  <div>
    <h2>Oops!</h2>
    <p>Something went wrong. We've been alerted.</p>
    <p><button onClick={() => window.location.reload(false)}>Click to reload!</button></p>
    <p className="tiny">{process.env.NODE_ENV} - v{rollbarConfig.server.code_version} - Rollbar {rollbarConfig.enabled ? 'ENABLED': 'DISABLED'}</p>
  </div>
);

function TestError() {
  const a = null;
  return a.hello();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

function parseJSON(response) {
  return response.json()
}

class StoreSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shopperLocation: null,  // make this always just what you need, like {city, state}, not the entire object
      pickupOrDelivery: 'pickup', // default to pickup?
    };

    // to reset cookie uncomment
    // cookies.remove('shopperLocation');
    // cookies.remove('pickupOrDelivery');
    // console.log('Loading fromm cookie: ');
    // console.log(location);

    // load pickupOrDelivery from cookies, or save to cookies
    let pickupOrDelivery = cookies.get('pickupOrDelivery');
    if (pickupOrDelivery && ['pickup', 'delivery'].some(item => pickupOrDelivery === item)) {
      this.state.pickupOrDelivery = pickupOrDelivery;
    } else {
      cookies.set('pickupOrDelivery', this.state.pickupOrDelivery, { path: '/' });
    }

    // load pickupOrDelivery from cookies, or load from storerocket and save to cookies
    let shopperLocation = cookies.get('shopperLocation');
    if (shopperLocation && shopperLocation.city && shopperLocation.state && shopperLocation.lat && shopperLocation.lng) {  // TODO: sanitize the cookie, make sure it's real
      this.state.shopperLocation = {city: shopperLocation.city, state: shopperLocation.state, lat: shopperLocation.lat, lng: shopperLocation.lng};
      this.refreshState();
    } else {  // use storerocket to get the default one
      let that = this;
      fetch('https://storerocket.io/api/location')
        .then(checkStatus)
        .then(parseJSON)
        .then(function(data) {
          console.log('request succeeded with JSON response', data)
  
          shopperLocation = {city: data.city, state: data.state, lat: data.lat, lng: data.lon};
          that.setState({
            shopperLocation: shopperLocation,
          }, that.refreshState);
          console.log('Setting cookie from Store Rocket');
        }).catch(function(error) {
          console.log('request failed', error)
      });
    }
  }

  componentDidMount() { 
    this._ismounted = true;
  }
  
  componentWillUnmount() {
     this._ismounted = false;
  }

  refreshState = () => {
    cookies.set('shopperLocation', this.state.shopperLocation, { path: '/' });
    cookies.set('pickupOrDelivery', this.state.pickupOrDelivery, { path: '/' });
  };

  handlePlaceChanged = (current) => {
    const place = current.getPlace();
    if (place) {
      // console.log(place.address_components);

      let [city, state] = this.extractCityState(place.address_components);
      console.log('Setting cookie from Google Autocomplete');
      // console.log(place);
      this.setState({
        shopperLocation: {
          city: city,
          state: state,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        },
      }, this.refreshState);

      console.log(this.state.shopperLocation);
      // console.log(place.geometry.location.lat())
      // console.log(place.geometry.location.lng())
    }
  };

  extractCityState = (address_components) => {
    let city = null;
    let state = null;

    address_components.forEach(element => {
      let index = element['types'].indexOf('locality');
      if (index >= 0) {
        city = element['long_name'];
      }
      index = element['types'].indexOf('administrative_area_level_1');
      if (index >= 0) {
        state = element['short_name'];
      }
    });
    return [city, state];
  };

  pickupSelected = () => {
    this.setState({
      pickupOrDelivery: 'pickup',
    }, this.refreshState);
  };

  deliverySelected = () => {
    this.setState({
      pickupOrDelivery: 'delivery',
    }, this.refreshState);
  };

  render() {
    return (
      <Provider config={rollbarConfig}>
        <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay}>
          <div className="store-selector">
            <div className="pickup-or-delivery">
              <button className={'pickup' === this.state.pickupOrDelivery ? 'active-class' : ''} onClick={this.pickupSelected}>Pick Up</button>
              <button className={'delivery' === this.state.pickupOrDelivery ? 'active-class' : ''} onClick={this.deliverySelected}>Delivery</button>
            </div>
            <br/>
            <div className="auto-complete">
              <PlaceComponent placeholder={this.state.shopperLocation} handlePlaceChanged={this.handlePlaceChanged}/>
            </div>
            <Locations shopperLocation={this.state.shopperLocation} pickupOrDelivery={this.state.pickupOrDelivery}/>
          </div>
          <p className="tiny">{process.env.NODE_ENV} - v{rollbarConfig.server.code_version}</p>
        </ErrorBoundary>
      </Provider>
    );
  }
}


// ========================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<StoreSelector />);  